import React from 'react';
import { Icon as AbyssIcon } from '@uhg-abyss/web/ui/Icon';

export const Icon = (props) => {
  return <AbyssIcon color="info1" {...props} />;
};
